import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import shape1 from '../../images/shape/line-shape03.png'
import shape2 from '../../images/shape/line-shape04.png'
import shape3 from '../../images/shape/pattern02.png'
import shape4 from '../../images/shape/monitor-shape.png'
import shape5 from '../../images/shape/blur-shape.png'
import servicenowlogo from '../../images/logo/servicenow.png'

const RoadmapSlider = () => {
    const prevRef = useRef(null);
    const nextRef = useRef(null);

    const roadmapData = [
        {
            quarter: "1",
            year: "ITSM",
            title: "IT Service Management",
            content:
                " Streamline IT services with automation and best practices to enhance efficiency, minimize downtime, and improve user experiences.",
        },
        {
            quarter: "2",
            year: "ITOM",
            title: "IT Operations Management",
            content:
                "Gain full visibility into your IT infrastructure, optimize performance, and proactively address issues before they impact business operations.",
        },
        {
            quarter: "3",
            year: "ITAM",
            title: "IT Asset Management",
            content:
                "Track, manage, and optimize IT assets throughout their lifecycle to reduce costs, ensure compliance, and maximize asset value.",
        },
        {
            quarter: "4",
            year: "ITBM",
            title: "IT Business Managemennt",
            content:
                "Align IT investments with business goals, prioritize resources effectively, and drive digital transformation with strategic planning.",
        },
        {
            quarter: "5",
            year: "HRSD",
            title: "HR Service Delivery",
            content:
                "Automate HR workflows, enhance employee experiences, and improve service delivery with self-service portals and AI-driven insights.",
        },
        {
            quarter: "6",
            year: "CSM",
            title: "Customer Service Management",
            content:
                " Elevate customer experiences with proactive support, AI-powered automation, and seamless case resolution across multiple channels.",
        }
    ];




    return (
        <section className="roadmap roadmap-pb pt-130 pb-200 pos-rel" style={{ backgroundColor: "#0F55DC" }}>
            <div className="container">
                <div className="sa-tes_top roadmap-top pos-rel mb-85">
                    <div className="sec-title--two">
                        <div className="sub-title sub-title--strock wow fadeInDown" data-wow-duration="600ms"><img src="assets/img/icon/process-icon.svg" alt="" />Our Module</div>
                        <h2 className="title clr-white wow fadeInDown" data-wow-delay="150ms" data-wow-duration="600ms">ServiceNow Modules for Smarter IT Operations</h2>
                    </div>
                    <div className="sa-tes_button roadmap-button">
                        <div className="sa-swiper-btn swiper-button-prev" ref={prevRef}><i className="fal fa-angle-left"></i></div>
                        <div className="sa-swiper-btn active swiper-button-next" ref={nextRef}><i className="fal fa-angle-right"></i></div>
                    </div>
                </div>
            </div>
            <div className="roadmap-slider-container">
                <Swiper
                    modules={[Navigation, Pagination, Autoplay]}
                    loop={true}
                    spaceBetween={50}
                    speed={400}
                    slidesPerView={3}
                    centeredSlides={true}
                    autoplay={{
                        delay: 6000,
                        disableOnInteraction: false,
                    }}
                    pagination={{
                        el: ".swiper-pagination",
                        clickable: true,
                    }}
                    navigation={{
                        nextEl: nextRef.current,
                        prevEl: prevRef.current,
                    }}
                    breakpoints={{
                        1600: {
                            slidesPerView: 3,
                        },
                        1024: {
                            slidesPerView: 3,
                            spaceBetween: 30,
                        },
                        768: {
                            slidesPerView: 2,
                        },
                        576: {
                            slidesPerView: 1,
                        },
                        0: {
                            slidesPerView: 1,
                        },
                    }}
                    className="raodmap-slider"
                >
                    {roadmapData.map((item, index) => (
                     <SwiperSlide key={index}>
  <div className="roadmap-item">
    <div className="xb-item--top logo-center">
      <img src={shape1} alt="" />
      <img src={servicenowlogo} alt="" height={200} width={150} />
      <img src={shape2} alt="" />
    </div>
    <div className="xb-item--holder">
      <span className="xb-item--year">{item.year}</span>
      <h3 className="xb-item--title">{item.title}</h3>
      <p className="xb-item--content">{item.content}</p>
    </div>
  </div>
</SwiperSlide>

                    ))}
                </Swiper>

                {/* Pagination */}
                <div className="swiper-pagination"></div>
            </div>
            <div className="roadmap-shape">
                <div className="shape shape--one"><img src={shape3} alt=""/></div>
                <div className="shape shape--two"><img src={shape4} alt=""/></div>
                <div className="shape shape--three"><img src={shape5} alt=""/></div>
            </div>
        </section>
    );
};

export default RoadmapSlider;
